import { gql } from '@apollo/client'

import { FRAGMENT_MY_BRAND_SOA } from '../fragments/myBrandSoa'
import { FRAGMENT_SOA_CATEGORY } from '../fragments/soaCategory'
import { FRAGMENT_WORKSPACE } from '../fragments/workspace'

export const GET_MY_BRAND_SOA = gql`
  query getMyBrandSoa {
    getWorkspace {
      ...FragmentWorkspace
      myBrandSoA {
        ...FragmentMyBrandSoa
        category {
          ...FragmentSoaCategory
        }
      }
    }
  }
  ${FRAGMENT_MY_BRAND_SOA}
  ${FRAGMENT_SOA_CATEGORY}
  ${FRAGMENT_WORKSPACE}
`
